import React, { useEffect, useMemo, useState } from "react";
import { makeStyles } from '@material-ui/core/styles';

import { useDispatch, useSelector } from "react-redux";

import moment from 'moment'

import { getConsultingId, getMonths } from "../../utils/utils";
import { Menu, MenuItem, Typography } from "@material-ui/core";
import { tabs } from "../../../assets/styles/unoTheme";

import allActions from "../../../actions";
import { doGetStatusClientsByYear } from "../../../controllers/ClientController";
import { StatusDpinDairAPI } from "../../../API/status_dpin_dair";
import { UserAPI } from "../../../API/user";
import { checkUserIsRole, roles } from "../../utils/user";
import UnoButton from "../../utils/UnoButton";
import MyDatePicker from '../../utils/MyDatePicker'
import MyAutoComplete from "../../utils/MyAutoComplete";
import MySelect2 from "../../utils/MySelect2";

import FilterListIcon from '@material-ui/icons/FilterList';
import HistoryIcon from '@material-ui/icons/History';

import { MyTab, MyTabs } from "../../utils/MyTabs";

import DairTab from "./statusClients/tabs/DairTab";
import DpinTab from "./statusClients/tabs/DpinTab";
import XmlAudespTab from "./statusClients/tabs/XmlAudespTab";

const useStyles = makeStyles((theme) => ({
    root: {
        display: 'flex',
        flexDirection: 'column',
        textAlign: 'left',
    },

    tabs: tabs,

    shortWidthTab: {
        '& .MuiTab-root': {
            minWidth: '100px !important',
            width: 'auto',
        }
    },

    tabsWithRight: {
        display: 'flex',
        flexDirection: 'row',
        paddingRight: '16px',
        alignItems: 'center',
        justifyContent: 'space-between',
    },

    rightHeader: {
        display: 'flex',
        alignItems: 'center',
    },
}));

export default function StatusClientsScreen(props) {

    const { selectedYearClosure } = props;

    const classes = useStyles();
    const dispatch = useDispatch();

    const currentUser = useSelector(state => state.currentUser)

    const [tabValue, setTabValue] = useState(0);

    const handleChangeTabValue = (event, newValue) => {
        setTabValue(newValue);
    };

    //Advisors
    const [activeAdvisors, setActiveAdvisors] = useState(null);
    async function doGetActiveAdvisorsAndAdmins() {
        const response = await UserAPI.getActiveAdvisorsAndAdminsByConsulting(getConsultingId(currentUser));
        if (response.success) {
            setActiveAdvisors(response.body.rows);
        }
    }

    const [selectedAdvisor, setSelectedAdvisor] = useState(currentUser.user);
    const handleAdvisorSelectedClient = (event, newValue) => {
        setSelectedAdvisor(newValue);
    }

    //Dados da tabela DAIR
    const [statusClientsArray, setStatusClientsArray] = useState(null);
    const [page, setPage] = useState(1);
    const [totalItems, setTotalItems] = useState(1);

    const [search, setSearch] = useState("");
    const [sortOrder, setSortOrder] = useState('alpha_asc');

    const LIMIT = 30;
    const handleChange = (value) => {
        const newPage = page + value;
        setOnSnapshot(false)
        setPage(newPage);
        loadClientsClosures(newPage, selectedYearClosure, selectedAdvisor, getConsultingId(currentUser), search, selectedDairFilter);
    };

    //Statuses
    const [statusesDpin, setStatusesDpin] = useState(null);
    const [statusesDair, setStatusesDair] = useState(null);
    const [statusesXmlAudesp, setStatusesXmlAudesp] = useState(null);

    //Apenas os status ativos podem ser escolhidos pelo usuário (troca de status, filtros e relatório).
    //As listas completas seguem sendo usadas para exibir registros já gravados.
    const activeStatusesDair = useMemo(() => (statusesDair || []).filter(el => el.active !== false), [statusesDair]);
    const activeStatusesDpin = useMemo(() => (statusesDpin || []).filter(el => el.active !== false), [statusesDpin]);

    //Filtros
    const [selectedDpinFilter, setSelectedDpinFilter] = useState(null);
    const [anchorElFilterDpin, setAnchorElFilterDpin] = useState(null);

    const [selectedDairFilter, setSelectedDairFilter] = useState(null);
    const [anchorElFilterDair, setAnchorElFilterDair] = useState(null);

    const [monthsFilterDair, setMonthsFilterDair] = useState(getMonths());
    const [filterDairMonthSelected, setFilterDairMonthSelected] = useState(new Date().getMonth());

    const [selectedXmlAudespFilter, setSelectedXmlAudespFilter] = useState(null);
    const [anchorElFilterXmlAudesp, setAnchorElFilterXmlAudesp] = useState(null);
    const [filterXmlAudespMonthSelected, setFilterXmlAudespMonthSelected] = useState(new Date().getMonth());

    //Snapshot
    const [inputSnapshotDate, setInputSnapshotDate] = React.useState(null);
    const [onSnapshot, setOnSnapshot] = React.useState(false);
    const [mySnapshotDate, setMySnapshotDate] = React.useState(null);

    async function loadClientsClosures(
        page,
        year,
        advisor,
        consultingId,
        search,
        dairFilter,
        filterDairMonthSelected,
        dpinFilter,
        snapshotDate) {

        dispatch(allActions.innerLoadActions.setInnerLoad({
            show: true,
            loadMessage: 'Carregando clientes...'
        }));

        setStatusClientsArray(null);
        const offset = (page - 1) * LIMIT;
        const advisorToFilter = advisor && advisor.id ? advisor.id : null;

        const dairStatusIdFilter = dairFilter ? dairFilter.id : null;
        const dpinStatusIdFilter = dpinFilter ? dpinFilter.id : null;

        const responseStatusClientsArray = await doGetStatusClientsByYear(
            offset,
            advisorToFilter == null
                && selectedDairFilter == null ? LIMIT : 'NO_PAGINATION',
            year,
            advisorToFilter,
            consultingId,
            search,
            dairStatusIdFilter,
            dairStatusIdFilter ? (parseInt(filterDairMonthSelected) + 1) //pois o mês array inicia com 0
                : null,
            dpinStatusIdFilter,
            snapshotDate,
            sortOrder
        );

        console.log("teste responseStatusClientsArray: ", responseStatusClientsArray.body)

        if (responseStatusClientsArray.success) {

            if (responseStatusClientsArray.body && responseStatusClientsArray.body.length) {
                console.log("responseStatusClientsArray.body: ", responseStatusClientsArray.body)
                setStatusClientsArray(responseStatusClientsArray.body);
                setTotalItems(responseStatusClientsArray.totalItems);
                dispatch(allActions.innerLoadActions.setInnerLoad({
                    show: false,
                }));

            } else {
                dispatch(allActions.innerLoadActions.setInnerLoad({
                    show: true,
                    emptyMessage: "Nenhum cliente encontrado",
                }));
            }

        } else {
            setStatusClientsArray(null);

            dispatch(allActions.innerLoadActions.setInnerLoad({
                show: true,
                emptyMessage: "Nenhum cliente encontrado",
            }));
        }

    }

    function handleOpenHistoryDrawer() {
        dispatch(allActions.rightContentActions.setRightContent({
            path: 'backofficeReportHistory',
            data: { year: selectedYearClosure }
        }));
    }

    function handleOpenGenerateBackofficeReportDrawer() {
        dispatch(allActions.rightContentActions.setRightContent({
            path: 'backofficeReportGenerator',
            data: {
                year: selectedYearClosure,
                statusesDair: activeStatusesDair,
                advisorId: selectedAdvisor && selectedAdvisor.id ? selectedAdvisor.id : null,
                advisors: activeAdvisors || [],
                selectedAdvisor: selectedAdvisor || null,
                consultingId: getConsultingId(currentUser),
                clientSearch: search || null,
            }
        }));
    }

    const handleChangeInputSnapshotDate = (date) => {

        setInputSnapshotDate(date);
        if (moment(date).isValid() && date.year() == selectedYearClosure) {
            setMySnapshotDate(moment.utc(date).format('DD/MM/YYYY'));
            setPage(1);
            setOnSnapshot(true)
            loadClientsClosures(
                1,
                selectedYearClosure,
                selectedAdvisor,
                getConsultingId(currentUser),
                search,
                null,
                null,
                null,
                moment.utc(date).format('DD/MM/YYYY')
            );

        } else if (moment(date).isValid() && date.getFullYear() != selectedYearClosure) {
            dispatch(allActions.mainAlertActions.setMainAlert({
                show: true,
                message: 'O ano da data selecionada deve ser igual ao ano do filtro [' + selectedYearClosure + ']',
                type: 'warning'
            }))
        } else if (date == undefined || date == '' || date == null) {

            setPage(1);
            loadClientsClosures(
                1,
                selectedYearClosure,
                selectedAdvisor,
                getConsultingId(currentUser),
                search,
                selectedDairFilter,
                filterDairMonthSelected,
                null);
            setOnSnapshot(false)
        }

    };

    const handleClickFilterDair = (event) => {
        setAnchorElFilterDair(event.currentTarget);
    };

    const handleClickFilterDpin = (event) => {
        setAnchorElFilterDpin(event.currentTarget);
    };

    const handleCloseFilterDair = () => {
        setAnchorElFilterDair(null);
    };

    const handleCloseFilterDpin = () => {
        setAnchorElFilterDpin(null);
    };

    function doSelectFilterDair(itemDair) {
        setSelectedDairFilter(itemDair)
        handleCloseFilterDair();
    }

    function doSelectFilterDpin(itemDpin) {
        setSelectedDpinFilter(itemDpin)
        handleCloseFilterDpin();
    }

    function renderMenuFilterDair(items) {

        const menuList = [];

        menuList.push(<MenuItem
            key={'menu-remove-filter-dairs'}
            onClick={() => doSelectFilterDair(null)}>
            <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                <div style={{
                    backgroundColor: 'black',
                    width: '8px',
                    height: '8px',
                    marginRight: '6px',
                    borderRadius: '50%'
                }}></div><Typography style={{ fontSize: '10px' }}>{'REMOVER FILTRO'}</Typography>
            </div>
        </MenuItem >);
        items.forEach(item => {
            menuList.push(<MenuItem
                key={'menu-filter-dairs-' + item.id}
                onClick={() => doSelectFilterDair(item)}>
                <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                    <div style={{
                        backgroundColor: item.color,
                        width: '8px',
                        height: '8px',
                        marginRight: '6px',
                        borderRadius: '50%'
                    }}></div><Typography style={{ fontSize: '10px' }}>{item.short_name} - {item.name}</Typography>
                </div>
            </MenuItem >);
        });

        return menuList;
    }

    function renderMenuFilterDpin(items) {

        const menuList = [];

        menuList.push(<MenuItem
            key={'menu-remove-filter-dpins'}
            onClick={() => doSelectFilterDpin(null)}>
            <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                <div style={{
                    backgroundColor: 'black',
                    width: '8px',
                    height: '8px',
                    marginRight: '6px',
                    borderRadius: '50%'
                }}></div><Typography style={{ fontSize: '10px' }}>{'REMOVER FILTRO'}</Typography>
            </div>
        </MenuItem >);
        items.forEach(item => {
            menuList.push(<MenuItem
                key={'menu-filter-dpins-' + item.id}
                onClick={() => doSelectFilterDpin(item)}>
                <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                    <div style={{
                        backgroundColor: item.color,
                        width: '8px',
                        height: '8px',
                        marginRight: '6px',
                        borderRadius: '50%'
                    }}></div><Typography style={{ fontSize: '10px' }}>{item.short_name} - {item.name}</Typography>
                </div>
            </MenuItem >);
        });

        return menuList;
    }

    const handleClickFilterXmlAudesp = (event) => {
        setAnchorElFilterXmlAudesp(event.currentTarget);
    };

    const handleCloseFilterXmlAudesp = () => {
        setAnchorElFilterXmlAudesp(null);
    };

    function doSelectFilterXmlAudesp(itemXmlAudesp) {
        setSelectedXmlAudespFilter(itemXmlAudesp)
        handleCloseFilterXmlAudesp();
    }

    function renderMenuFilterXmlAudesp(items) {

        const menuList = [];

        menuList.push(<MenuItem
            key={'menu-remove-filter-xml-audesp'}
            onClick={() => doSelectFilterXmlAudesp(null)}>
            <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                <div style={{
                    backgroundColor: 'black',
                    width: '8px',
                    height: '8px',
                    marginRight: '6px',
                    borderRadius: '50%'
                }}></div><Typography style={{ fontSize: '10px' }}>{'REMOVER FILTRO'}</Typography>
            </div>
        </MenuItem >);
        items.forEach(item => {
            menuList.push(<MenuItem
                key={'menu-filter-xml-audesp-' + item.id}
                onClick={() => doSelectFilterXmlAudesp(item)}>
                <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                    <div style={{
                        backgroundColor: item.color,
                        width: '8px',
                        height: '8px',
                        marginRight: '6px',
                        borderRadius: '50%'
                    }}></div><Typography style={{ fontSize: '10px' }}>{item.short_name} - {item.name}</Typography>
                </div>
            </MenuItem >);
        });

        return menuList;
    }

    async function loadStatuses() {
        const promises = [];

        promises.push(new Promise(async (resolve, reject) => {
            let response = await StatusDpinDairAPI.getStatusesDpin();
            if (response.success) {
                resolve(response.body);
            } else {
                resolve(false);
            }
        }))

        promises.push(new Promise(async (resolve, reject) => {
            let response = await StatusDpinDairAPI.getStatusesDair();
            if (response.success) {
                resolve(response.body);
            } else {
                resolve(false);
            }
        }))

        promises.push(new Promise(async (resolve, reject) => {
            let response = await StatusDpinDairAPI.getStatusesXmlAudesp();
            if (response.success) {
                resolve(response.body);
            } else {
                resolve(false);
            }
        }))

        const responseAll = await Promise.all(promises);
        console.log('responseAll: ', responseAll);
        setStatusesDpin(responseAll[0].rows);
        setStatusesDair(responseAll[1].rows);
        setStatusesXmlAudesp(responseAll[2] ? responseAll[2].rows : null);
    }

    useEffect(() => {
        setPage(1);
        loadClientsClosures(1,
            selectedYearClosure,
            selectedAdvisor,
            getConsultingId(currentUser),
            search, selectedDairFilter, filterDairMonthSelected, null);
        setOnSnapshot(false)

    }, [selectedYearClosure, selectedAdvisor, search, selectedDairFilter, filterDairMonthSelected, sortOrder]);

    useEffect(() => {

        loadStatuses();
        doGetActiveAdvisorsAndAdmins();
        loadClientsClosures(1,
            selectedYearClosure,
            selectedAdvisor,
            getConsultingId(currentUser),
            search, null, null, null);
        setOnSnapshot(false)

    }, []);

    const advisorFilter = activeAdvisors ?
        <MyAutoComplete
            id={'advisor-filter-status-client'}
            disabled={!checkUserIsRole(currentUser, [roles.superadmin, roles.admin])}
            options={activeAdvisors}
            autoComplete
            customWidth={'250px'}
            value={
                selectedAdvisor ? selectedAdvisor : null
            }
            onChange={(event, newValue) => {
                console.log("New value: ", newValue)
                handleAdvisorSelectedClient(event, newValue)
            }}
            label={'Consultor'}
            placeholder={"Selecione o consultor"}
            getOptionLabel={(option) => option.name.toUpperCase()}
            getOptionSelected={(option, value) => option.id === value.id}
            renderOption={(option) => (
                <React.Fragment key={'autocomplete-' + option.id}>
                    <span>{option.name.toUpperCase()}</span>
                </React.Fragment>
            )}
        /> : <Typography variant='body1' style={{ whiteSpace: 'nowrap', marginRight: '16px' }}>{selectedAdvisor && selectedAdvisor.name.toUpperCase()}</Typography>;

    return (
        <div className={classes.root}>

            <div className={classes.tabsWithRight}>

                <div className={[classes.tabs, classes.shortWidthTab].join(' ')} style={{ width: 'auto' }}>
                    <MyTabs
                        value={tabValue}
                        indicatorColor="primary"
                        textColor="primary"
                        onChange={handleChangeTabValue}>

                        <MyTab label="DAIR" value={0} />
                        <MyTab label="DPIN" value={1} />
                        <MyTab label="XML - AUDESP" value={2} />

                    </MyTabs>
                </div>

                {
                    tabValue === 0 &&
                    <div className={classes.rightHeader}>

                        {
                            checkUserIsRole(currentUser, [roles.admin, roles.superadmin]) ?
                                <MyDatePicker
                                    defaultValue={null}
                                    style={{
                                        marginTop: '0px',
                                        marginRight: '16px',
                                        width: '160px'
                                    }}
                                    margin="dense"
                                    format="DD/MM/YYYY"
                                    value={inputSnapshotDate}
                                    onChange={handleChangeInputSnapshotDate} /> : null
                        }

                        {
                            (!inputSnapshotDate || inputSnapshotDate == '' || !moment(inputSnapshotDate).isValid()) ?

                                <UnoButton
                                    style={selectedDairFilter ?
                                        { marginRight: '16px', color: selectedDairFilter.color, border: 'solid 1px ' + selectedDairFilter.color }
                                        : { marginRight: '16px' }}
                                    startIcon={<FilterListIcon />}
                                    onClick={handleClickFilterDair}
                                    type='primaryClean'>
                                    {selectedDairFilter ? selectedDairFilter.short_name : "DAIR"}
                                </UnoButton>
                                : null
                        }

                        {
                            selectedDairFilter && (!inputSnapshotDate || inputSnapshotDate == '' || !moment(inputSnapshotDate).isValid()) ?
                                <MySelect2
                                    style={{ marginTop: '0px', marginRight: '16px' }}
                                    id={'months-in-filter-dair'}
                                    value={filterDairMonthSelected}
                                    onChange={(e) => setFilterDairMonthSelected(e.target.value)}
                                    options={monthsFilterDair.map((row, index) => (
                                        <option key={'month-filter-dair-' + index} value={index}>
                                            {row}
                                        </option>
                                    ))}
                                /> : null
                        }

                        {advisorFilter}
                        {checkUserIsRole(currentUser, [roles.superadmin, roles.admin, roles.manager, roles.submanager]) && <>
                            <UnoButton
                                isIconButton
                                onClick={handleOpenGenerateBackofficeReportDrawer}
                                size='small'
                                type='primary'
                            />

                            <UnoButton
                                isIconButton
                                style={{ marginLeft: '8px' }}
                                myIcon={<HistoryIcon />}
                                onClick={handleOpenHistoryDrawer}
                                type='primaryClean'>
                            </UnoButton>
                        </>}

                    </div>
                }

                {
                    tabValue === 1 &&
                    <div className={classes.rightHeader}>

                        <UnoButton
                            style={selectedDpinFilter ?
                                { marginRight: '16px', color: selectedDpinFilter.color, border: 'solid 1px ' + selectedDpinFilter.color }
                                : { marginRight: '16px' }}
                            startIcon={<FilterListIcon />}
                            onClick={handleClickFilterDpin}
                            type='primaryClean'>
                            {selectedDpinFilter ? selectedDpinFilter.short_name + ' - ' + selectedDpinFilter.name : "DPIN"}
                        </UnoButton>

                        {advisorFilter}

                    </div>
                }

                {
                    tabValue === 2 &&
                    <div className={classes.rightHeader}>

                        <UnoButton
                            style={selectedXmlAudespFilter ?
                                { marginRight: '16px', color: selectedXmlAudespFilter.color, border: 'solid 1px ' + selectedXmlAudespFilter.color }
                                : { marginRight: '16px' }}
                            startIcon={<FilterListIcon />}
                            onClick={handleClickFilterXmlAudesp}
                            type='primaryClean'>
                            {selectedXmlAudespFilter ? selectedXmlAudespFilter.short_name : "XML - AUDESP"}
                        </UnoButton>

                        {
                            selectedXmlAudespFilter ?
                                <MySelect2
                                    style={{ marginTop: '0px', marginRight: '16px' }}
                                    id={'months-in-filter-xml-audesp'}
                                    value={filterXmlAudespMonthSelected}
                                    onChange={(e) => setFilterXmlAudespMonthSelected(e.target.value)}
                                    options={monthsFilterDair.map((row, index) => (
                                        <option key={'month-filter-xml-audesp-' + index} value={index}>
                                            {row}
                                        </option>
                                    ))}
                                /> : null
                        }

                        {advisorFilter}

                    </div>
                }

            </div>

            {tabValue === 0 &&
                <DairTab
                    selectedYearClosure={selectedYearClosure}
                    statusClientsArray={statusClientsArray}
                    setStatusClientsArray={setStatusClientsArray}
                    statusesDair={statusesDair}
                    activeStatusesDair={activeStatusesDair}
                    page={page}
                    totalItems={totalItems}
                    handlePage={handleChange}
                    limit={LIMIT}
                    search={search}
                    setSearch={setSearch}
                    sortOrder={sortOrder}
                    setSortOrder={setSortOrder}
                    selectedAdvisor={selectedAdvisor}
                    selectedDairFilter={selectedDairFilter}
                    filterDairMonthSelected={filterDairMonthSelected}
                    mySnapshotDate={mySnapshotDate}
                    onSnapshot={onSnapshot}
                />
            }
            {tabValue === 1 && <DpinTab selectedYearClosure={selectedYearClosure} selectedDpinFilter={selectedDpinFilter} selectedAdvisor={selectedAdvisor} />}
            {tabValue === 2 && <XmlAudespTab
                selectedYearClosure={selectedYearClosure}
                selectedAdvisor={selectedAdvisor}
                selectedXmlAudespFilter={selectedXmlAudespFilter}
                filterMonth={selectedXmlAudespFilter ? (parseInt(filterXmlAudespMonthSelected) + 1) : null}
            />}

            {activeStatusesDair.length ?
                <Menu
                    id="filter-dair-menu"
                    anchorEl={anchorElFilterDair}
                    keepMounted
                    open={Boolean(anchorElFilterDair)}
                    onClose={handleCloseFilterDair}>
                    {renderMenuFilterDair(activeStatusesDair)}
                </Menu> : null
            }

            {activeStatusesDpin.length ?
                <Menu
                    id="filter-dpin-menu"
                    anchorEl={anchorElFilterDpin}
                    keepMounted
                    open={Boolean(anchorElFilterDpin)}
                    onClose={handleCloseFilterDpin}>
                    {renderMenuFilterDpin(activeStatusesDpin)}
                </Menu> : null
            }

            {statusesXmlAudesp && statusesXmlAudesp.length ?
                <Menu
                    id="filter-xml-audesp-menu"
                    anchorEl={anchorElFilterXmlAudesp}
                    keepMounted
                    open={Boolean(anchorElFilterXmlAudesp)}
                    onClose={handleCloseFilterXmlAudesp}>
                    {renderMenuFilterXmlAudesp(statusesXmlAudesp)}
                </Menu> : null
            }

        </div>
    );
}
